/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_Point_2_LabelInputs */

const en_visa_eb2niw_point_2_label = /** @type {(inputs: Visa_Eb2niw_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case Framing`)
};

const pt_visa_eb2niw_point_2_label = /** @type {(inputs: Visa_Eb2niw_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enquadramento do Caso`)
};

const es_visa_eb2niw_point_2_label = /** @type {(inputs: Visa_Eb2niw_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuadre del Caso`)
};

/**
* | output |
* | --- |
* | "Case Framing" |
*
* @param {Visa_Eb2niw_Point_2_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_point_2_label = /** @type {((inputs?: Visa_Eb2niw_Point_2_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_Point_2_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_point_2_label(inputs)
	if (locale === "es") return es_visa_eb2niw_point_2_label(inputs)
	return en_visa_eb2niw_point_2_label(inputs)
});